<template>
    <div id="reservation" class="popin-modal from-sides right" v-bind:class="{ 'active': isPopinLoaded }"
        v-show="isPopinDisplayed" v-observe-visibility="{ callback: popin_reservationDisplayed_callback }">
        <div class="popin-container">
            <div class="popin-closure" v-on:click="popin_reservationClosed">
                <div class="arrow"></div>
            </div>
            <div class="popin-closure-responsive" v-on:click="popin_reservationClosed">
                <div class="arrow">X</div>
            </div>
            <div class="popin">
                <div v-bind:class="{ 'popin-content': true, 'loaded': isPopinLoaded }">
                    <template v-if="isPopinLoaded">
                        <span class="title">Réservation pour {{ scenarioInformations[currentScenario] }}</span>
                        <span class="title-details" v-if="currentScenario == 'nestor-bomb-simulator'">Cette réservation donne droit à 4 parties de 15 minutes de NESTOR</span>
                        <div class="popin-content-container choix-episode" v-if="currentPopinName == 'choix-episode'">
                            <span class="recap-confirmation">
                                Cette aventure comporte deux épisodes de 60 minutes !
                            </span>
                            <span>
                                Vous pouvez jouer chaque épisode l'un après l'autre de façon indépendante,
                                <br />ou jouer les deux épisodes enchaînés en une grande aventure immersive !
                            </span>
                            <div class="form-episodes">
                                <div class="lq-col-2">
                                    <div>
                                        <button v-on:click="choixEpisode_buttonClicked('single', 1)">Épisode 1 seul</button>
                                        <span>Durée : 60 minutes</span>
                                    </div>
                                    <div>
                                        <button v-on:click="choixEpisode_buttonClicked('single', 2)">Épisode 2 seul</button>
                                        <span>Durée : 60 minutes</span>
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <button v-on:click="choixEpisode_buttonClicked('full')">
                                            Épisode 1 + épisode 2
                                            <br /><span>Profitez de l'aventure complète en totale immersion !</span>
                                        </button>
                                        <span>Durée : 120 minutes</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-bind:class="confirmationEpisode_bindClass()" v-if="currentPopinName == 'confirmation-episode'">
                            <span class="recap-confirmation" v-if="format_episode == 'single' && numero_episode == 2">
                                Vous avez choisi de réserver l'épisode 2 seul
                            </span>
                            <span class="recap-confirmation" v-else-if="format_episode == 'full'">
                                Vous avez choisi de réserver l'aventure complète (épisode 1 + 2)
                            </span>
                            <div class="form-infos with-warning" v-if="should_requestWarning1confirmation">
                                <span>Pour profiter pleinement de cette aventure, il est nécessaire d'avoir déjà joué l'épisode 1 !</span>
                                <label for="form_episode2warning1Checked" class="checkbox-container">
                                    Je confirme vouloir réserver l'épisode 2<span class="mandatory">*</span>
                                    <input type="checkbox" id="form_episode2warning1Checked" name="form_episode2warning1Checked" 
                                        v-model="formReservationInfos_episode2warning1Checked" v-on:input="confirmationEpisodeConfirmButton_bindClass">
                                    <span class="checkmark"></span>	
                                </label>
                            </div>
                            <div class="form-infos with-warning" v-if="should_requestWarning2confirmation">
                                <span>
                                    Durant cette aventure, vous serez amenés à crapahuter et arpenter des espaces étroits dans lesquels 
                                    il faut s'accroupir. Par conséquent, préférez une tenue dans laquelle vous êtes à l'aise et libre de vos mouvements.
                                </span>
                                <label for="form_episode2warning2Checked" class="checkbox-container">
                                    Je confirme avoir pris connaissance des recommandations ci-dessus<span class="mandatory">*</span>
                                    <input type="checkbox" id="form_episode2warning2Checked" name="form_episode2warning2Checked" 
                                        v-model="formReservationInfos_episode2warning2Checked" v-on:input="confirmationEpisodeConfirmButton_bindClass">
                                    <span class="checkmark"></span>	
                                </label>
                            </div>
                            <div class="form-confirmation-episode">
                                <div class="lq-col-2">
                                    <div>
                                        <button v-bind:class="confirmationEpisodeConfirmButton_bindClass()" v-on:click="confirmerEpisode_buttonClicked(true)">Continuer</button>
                                    </div>
                                    <div>
                                        <button v-on:click="confirmerEpisode_buttonClicked(false)">J'ai changé d'avis !</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="popin-content-container reservation-creneau" v-if="currentPopinName == 'reservation-creneau'">
                            <div>
                                <div class="column left">
                                    <Calendrier ref="reservationCalendrier"
                                        v-bind:view_isAdmin="view_paymentDelayed" v-bind:view_scenarioSlug="currentScenario"
                                        v-on:calendrier_daySelected="calendrier_daySelected" v-on:calendrier_dayUnselected="calendrier_dayUnselected" />
                                </div><!--

                                --><div class="column right">
                                    <div id="creneaux">
                                        <template v-if="creneaux_jour">
                                            <div class="liste-creneaux">
                                                <span>Choisissez un horaire</span>
                                                <div>
                                                    <span v-for="creneau_key in creneaux_keys" v-on:click="choixCreneau_click" v-bind:data-creneau="creneau_key"
                                                        v-bind:class="choixCreneau_bindClass(creneau_key)" class="creneau">
                                                            {{ creneaux_jour[creneau_key].label }}
                                                            <template v-if="creneauRoom_getAvailableType(creneau_key) == 'available_phone' && !view_paymentDelayed">
                                                                <span> &#x260E</span>
                                                            </template>
                                                        </span>
                                                </div>
                                            </div>
                                            <div class="wordings-creneaux" v-if="creneauxRoom_getAvailableType(creneaux_keys) == 'available_phone'">
                                                <span>&#x260E vérifiez la disponibilité au 07 82 42 47 16</span>
                                            </div>
                                        </template>

                                        <div class="creneaux-error" v-else>
                                            <span>Veuillez sélectionner une journée<br />dans le calendrier sur la gauche</span>
                                        </div>
                                    </div>

                                    <div id="compositions">
                                        <div class="liste-compositions" v-if="currentCreneau">
                                            <template v-if="creneauRoom_getAvailableType(currentCreneau) == 'available'">
                                                <span>Choisissez le nombre de personnes</span>
                                                <div>
                                                    <span data-composition="2" v-on:click="choixComposition_click" v-bind:class="choixComposition_bindClass(2)" class="composition">2</span>
                                                    <span data-composition="3" v-on:click="choixComposition_click" v-bind:class="choixComposition_bindClass(3)" class="composition">3</span>
                                                    <span data-composition="4" v-on:click="choixComposition_click" v-bind:class="choixComposition_bindClass(4)" class="composition">4</span>
                                                    <span data-composition="5" v-on:click="choixComposition_click" v-bind:class="choixComposition_bindClass(5)" class="composition">5</span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <span>Une envie de dernière minute ? Appelez-nous au 07 82 42 47 16 !</span>
                                            </template>
                                        </div>

                                        <div v-else-if="creneaux_jour" class="compositions-error" v-bind:class="{ 'available_phone': creneauxRoom_getAvailableType(creneaux_keys) == 'available_phone' }">
                                            <span>Veuillez sélectionner un créneau parmi <br />ceux disponibles ci-dessus</span>
                                        </div>
                                    </div>

                                    <div id="confirmation" v-if="currentCreneau && currentComposition">
                                        <button v-on:click="reserver_buttonClicked">Réserver</button>
                                        <span>Le {{ calendarDay }} {{ calendarLabel }} à {{ creneaux_jour[currentCreneau].label }} {{ currentComposition }} joueurs</span>
                                    </div>
                                </div>
                            </div>

                            <div v-if="!currentCreneau || !currentComposition" class="moyens-paiement">
                                <img src="/public/assets/images/icons_reservation_moyens_paiement.png" />
                                <span><span>Chèques vacances, espèces</span> : un acompte CB vous sera demandé en fin d'inscription</span>
                                <span><span>Pass Culture</span> : inscription par téléphone au 07 82 42 47 16 muni de votre code</span>
                            </div>

                            <div>
                                <div class="legende">
                                    <span class="not_available"></span>
                                    <span>Non disponible</span>
                                </div>
                                <div class="legende">
                                    <span class="available"></span>
                                    <span>Disponible</span>
                                </div>
                                <div class="legende">
                                    <span class="last_chance"></span>
                                    <span>Dernières places</span>
                                </div>
                                <div class="legende">
                                    <span class="full"></span>
                                    <span>Complet</span>
                                </div>
                                <div class="legende">
                                    <span class="active"></span>
                                    <span>Sélection</span>
                                </div>
                            </div>
                        </div>

                        <div class="popin-content-container choix-mode" v-else-if="currentPopinName == 'choix-mode'">
                            <span class="recap-confirmation">
                                Choisissez un niveau de jeu
                            </span>
                            <div class="form-modes">
                                <div v-on:click="choixGameMode_click('decouverte')">
                                    <div class="icon decouverte"></div>
                                    <span>Classique</span>
                                </div><!--
                                --><div v-on:click="choixGameMode_click('intermediaire')">
                                    <div class="icon intermediaire"></div>
                                    <span>Challenge</span>
                                </div><!--
                                --><div v-on:click="choixGameMode_click('confirme')">
                                    <div class="icon confirme"></div>
                                    <span>Expert</span>
                                </div>
                            </div>
                            <div class="form-modes-tips">
                                <div>
                                    <span>Classique - Difficulté : 6/10</span>
                                    Vous devrez faire preuve de logique, d'observation et être bien 
                                    organisés pour vous en sortir... Pas fastoche ! Ce mode est vivement conseillé si vous 
                                    débutez ou êtes en présence de plus jeunes (8 ans et +).
                                </div>
                                <div>
                                    <span>Challenge - Difficulté : 8/10</span>
                                    Vous êtes un habitué des Escape Game ? Ce mode de jeu pourrait vous 
                                    challenger avec moins d'indices et des énigmes plus corsées.
                                </div>
                                <div>
                                    <span>Expert - Difficulté : 10/10</span>
                                    Vous sortez toujours en moins de 50 minutes des salles d'Escape Game ? 
                                    Voici un mode de jeu concocté spécialement pour ceux qui recherchent un véritable défi !
                                </div>
                            </div>
                        </div>

                        <div class="popin-content-container check-creneau-reservation-in-progress" v-else-if="currentPopinName == 'check-creneau-reservation-in-progress'">
                            <span>Nous vérifions la disponibilité du créneau sélectionné...</span>
                        </div>

                        <div class="popin-content-container check-creneau-reservation-in-progress-error" v-else-if="currentPopinName == 'check-creneau-reservation-in-progress-error'">
                            <span>Désolé ! Ce créneau n'est plus disponible !</span>
                            <span><a v-on:click="changer_onClick">Choisir un autre créneau</a></span>
                        </div>

                        <div class="popin-content-container reservation-infos" v-else-if="currentPopinName == 'reservation-infos'">
                            <span class="recap-confirmation">
                                Réservation pour {{ currentComposition }} personnes le {{ calendarDay }} {{ calendarLabel }} à {{ creneaux_jour[currentCreneau].label }}
                                <a v-on:click="changer_onClick">Changer</a>
                            </span>
                            <span class="rappel-mode-de-jeu">
                                <template v-if="currentGameMode == 'confirme'">Vous avez choisi le mode Expert</template>
                                <template v-if="currentGameMode == 'intermediaire'">Vous avez choisi le mode Challenge</template>
                                <template v-else-if="currentGameMode == 'decouverte'">Vous avez choisi le mode Classique</template>
                            </span>
                            <div class="form-infos">
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>Nom de l'équipe<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formReservationInfos_teamName" v-bind:class="formReservationInfos_bindClass(formReservationInfos_teamName)" />
                                    </div>
                                    <div class="input-right">
                                        <span>Raison sociale</span>
                                        <input type="text" v-model="formReservationInfos_businessName" />
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>Nom<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formReservationInfos_lastName" v-bind:class="formReservationInfos_bindClass(formReservationInfos_lastName)" />
                                    </div>
                                    <div class="input-right">
                                        <span>Prénom<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formReservationInfos_firstName" v-bind:class="formReservationInfos_bindClass(formReservationInfos_firstName)" />
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>Adresse</span>
                                        <input type="text" v-model="formReservationInfos_address" />
                                    </div>
                                    <div class="input-right">
                                        <span>Code postal</span>
                                        <input type="text" v-model="formReservationInfos_zipCode" />
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>Ville</span>
                                        <input type="text" v-model="formReservationInfos_city" />
                                    </div>
                                    <div class="input-right">
                                        <span>Téléphone<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formReservationInfos_phoneNumber" v-bind:class="formReservationInfos_bindClass(formReservationInfos_phoneNumber)" />
                                    </div>
                                </div>
                                <div class="input-group">
                                    <div class="input-left">
                                        <span>Adresse email<span class="mandatory">*</span></span>
                                        <input type="text" v-model="formReservationInfos_email" v-bind:class="formReservationInfos_bindClass(formReservationInfos_email)" />
                                    </div>
                                    <div class="input-right">
                                        <span>Langue<span class="mandatory">*</span></span>
                                        <input type="text" disabled="disabled" value="Français" />
                                    </div>
                                </div>    
                                <div class="input-group">
                                    <div class="input-full">
                                        <span class="normal-block mw1120">
                                            Entrez ici le code d'un bon cadeau ou un code promo
                                            <span class="infos">(En cours de validité, à présenter impérativement à votre arrivée)</span>
                                        </span>
                                        <span class="responsive-block mw1120">
                                            Code promo
                                            <span class="infos">
                                                En cours de validité *
                                                <br />À présenter impérativement à votre arrivée **
                                            </span>
                                        </span>
                                        <input type="text" v-model="formReservationInfos_giftCardOrVoucherCode" v-on:blur="bonCadeauOuCodePromo_check"/>
                                        <div class="gift-card-or-voucher-code_checkmark" v-if="bonCadeauOuCodePromoProcess_amount > 0"></div>
                                    </div>
                                </div>
                                <div class="information responsive-block mw1120">
                                    En cas d'utilisation d'un code promo, ce dernier doit être valide
                                    <br /> et devra être présenté impérativement à votre arrivée
                                </div>
                                <div class="input-self">
                                    <label for="form_CGVChecked" class="checkbox-container">
                                        J'ai lu et j'accepte sans réserve les termes des C.G.V.<span class="mandatory">*</span>
                                        <input type="checkbox" id="form_CGVChecked" name="form_CGVChecked" v-model="formReservationInfos_areTermsAgreed">
                                        <span class="checkmark"></span>	
                                    </label>
                                </div>
                                <div class="form-submit">
                                    <span class="form-error">{{ formReservationInfos_error }}</span>
                                    <div v-if="tarifs" v-bind:class="{ 'acompte': (getTarif() - bonCadeauOuCodePromoProcess_amount) > getTarif() / currentComposition }">
                                        <button v-bind:disabled="!tarifs && bonCadeauOuCodePromoProcess_isChecking" v-on:click="payer_buttonClicked(true)">
                                            Payer ({{ getTarif() - bonCadeauOuCodePromoProcess_amount }}€ TTC)
                                        </button>
                                        <button v-if="(getTarif() - bonCadeauOuCodePromoProcess_amount) > getTarif() / currentComposition"
                                            v-bind:disabled="!tarifs && bonCadeauOuCodePromoProcess_isChecking" v-on:click="payer_buttonClicked(false)">
                                            Payer un acompte ({{ getTarif() / currentComposition }}€ TTC)
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="popin-content-container refresh-creneau-reservation-in-progress" v-else-if="currentPopinName == 'refresh-creneau-reservation-in-progress'">
                            <span>Nous vérifions la disponibilité du créneau sélectionné...</span>
                        </div>

                        <div class="popin-content-container refresh-creneau-reservation-in-progress-error" v-else-if="currentPopinName == 'refresh-creneau-reservation-in-progress-error'">
                            <span>Désolé ! Ce créneau n'est plus disponible !</span>
                            <span><a v-on:click="changer_onClick">Choisir un autre créneau</a></span>
                        </div>

                        <div class="popin-content-container reservation-process" v-else-if="currentPopinName == 'reservation-process'">
                            <span v-html="reservationProcess_message"></span>

                            <form v-if="moneticoFields" method="post" target="_top" 
                                action="https://p.monetico-services.com/paiement.cgi" ref="moneticoForm">
                                <input type="hidden" name="ThreeDSecureChallenge" v-bind:value="moneticoFields.ThreeDSecureChallenge">
                                <input type="hidden" name="version" v-bind:value="moneticoFields.version">
                                <input type="hidden" name="TPE" v-bind:value="moneticoFields.TPE">
                                <input type="hidden" name="date" v-bind:value="moneticoFields.date">
                                <input type="hidden" name="montant" v-bind:value="moneticoFields.montant">
                                <input type="hidden" name="reference" v-bind:value="moneticoFields.reference">
                                <input type="hidden" name="MAC" v-bind:value="moneticoFields.MAC">
                                <input type="hidden" name="url_retour" v-bind:value="moneticoFields.url_retour">
                                <input type="hidden" name="url_retour_ok" v-bind:value="moneticoFields.url_retour_ok">
                                <input type="hidden" name="url_retour_err" v-bind:value="moneticoFields.url_retour_err">
                                <input type="hidden" name="lgue" v-bind:value="moneticoFields.lgue">
                                <input type="hidden" name="societe" v-bind:value="moneticoFields.societe">
                                <input type="hidden" name="contexte_commande" v-bind:value="moneticoFields.contexte_commande">
                                <input type="hidden" name="mail" v-bind:value="moneticoFields.mail">
                            </form>
                        </div>
                    </template>
                    <template v-else>
                        <Loader />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

import Calendrier from './Calendrier.vue';
import Loader from './Loader.vue';

import anime from 'animejs/lib/anime.es';
import axios from 'axios';

import { v4 as uuidv4 } from 'uuid';

export default {
    name: "Reservation",
    components: {
        Calendrier,
        Loader
    },
    data: () => ({
        // popin parameters
        isPopinDisplayed: false,
        isPopinLoaded: false,
        currentPopinName: '',
        // current reservation parameters
        reservationInProgress_identifier: null,
        currentScenario: null,
        currentCreneau: null,
        currentComposition: null,
        currentGameMode: null,
        format_episode: null,
        numero_episode: null,
        should_requestWarning1confirmation: false,
        should_requestWarning2confirmation: false,
        // informations from calendrier component
        creneaux_keys: null,
        creneaux_jour: null,
        calendarLabel: null,
        calendarDay: null,
        calendarMonth: null,
        calendarYear: null,
        // scenarios informations
        scenarioInformations: {
            'le-tombeau-de-siptah': 'Le tombeau de Siptah',
            'le-secret-de-mayoko': 'Le secret de Mayoko',
            'les-gardiens-de-vichama': 'Les gardiens de Vichama',
            'le-talisman-des-titans': 'Le talisman des titans',
            'la-legende-d-ishtar': 'La légende d\'Ishtar',
            'nestor-bomb-simulator': 'NESTOR - Bomb Simulator'
        },
        destinations_and_rooms: {
            'le-tombeau-de-siptah': 'room_1',
            'le-secret-de-mayoko': 'room_2',
            'les-gardiens-de-vichama': 'room_3',
            'le-talisman-des-titans': 'room_4',
            'la-legende-d-ishtar': 'room_5',
            'nestor-bomb-simulator': 'room_6'
        },
        // tarifs informations
        tarifs: null,
        // payment informations
        moneticoFields: null,
        // reservation form parameters
        formReservationInfos_teamName: null,
        formReservationInfos_lastName: null,
        formReservationInfos_firstName: null,
        formReservationInfos_email: null,
        formReservationInfos_phoneNumber: null,
        formReservationInfos_businessName: null,
        formReservationInfos_address: null,
        formReservationInfos_zipCode: null,
        formReservationInfos_city: null,
        formReservationInfos_language: 'FR',
        formReservationInfos_giftCardOrVoucherCode: null,
        formReservationInfos_areTermsAgreed: false,
        formReservationInfos_episode2warning1Checked: false,
        formReservationInfos_episode2warning2Checked: false,
        formReservationInfos_isFullPaymentRequested: false,
        formReservationInfos_isSubmit: false,
        formReservationInfos_error: null,
        // bon cadeau handling
        bonCadeauOuCodePromoProcess_isChecking: false,
        bonCadeauOuCodePromoProcess_amount: 0,
        // reservation process
        reservationProcess_message: null
    }),
    props: {
        view_paymentDelayed: { type: Boolean, default: false }
    },
    methods: {
        getTarif: function() {
            var tarif = this.tarifs[this.currentComposition];
            if (this.format_episode && this.format_episode == 'full') {
                tarif = tarif * 2;
            }
            
            return tarif;
        },
        choixEpisode_buttonClicked: function(format_episode, numero_episode) {
            this.format_episode = format_episode;
            this.numero_episode = numero_episode;

            if (this.format_episode == 'full') {
                this.should_requestWarning2confirmation = true;
                this.currentPopinName = 'confirmation-episode';
            } else if (this.numero_episode == 2) {
                this.should_requestWarning1confirmation = true;
                this.should_requestWarning2confirmation = true;
                this.currentPopinName = 'confirmation-episode';
            } else {
                this.currentPopinName = 'reservation-creneau';
                
                var self = this;
                Vue.nextTick(function() {
                    self.$refs.reservationCalendrier.initializeCalendrier();
                });
            }
        },
        confirmationEpisode_bindClass: function() {
            var obj = {
                'popin-content-container': true,
                'confirmation-episode': true
            };

            obj[this.format_episode] = true;
            return obj;
        },
        confirmationEpisodeConfirmButton_bindClass: function() {
            if (this.should_requestWarning1confirmation && !this.formReservationInfos_episode2warning1Checked) {
                return { 'disabled': true };
            } else if (this.should_requestWarning2confirmation && !this.formReservationInfos_episode2warning2Checked) {
                return { 'disabled': true };
            }
        },
        confirmerEpisode_buttonClicked: function(status) {
            if (status) {
                if (this.should_requestWarning1confirmation && !this.formReservationInfos_episode2warning1Checked) {
                    return;
                } else if (this.should_requestWarning2confirmation && !this.formReservationInfos_episode2warning2Checked) {
                    return;
                }

                this.currentPopinName = 'reservation-creneau';
                
                var self = this;
                Vue.nextTick(function() {
                    self.$refs.reservationCalendrier.initializeCalendrier();
                });
            } else {
                this.format_episode = null;
                this.numero_episode = null;
                this.formReservationInfos_episode2warning1Checked = false;
                this.should_requestWarning1confirmation = false;
                this.should_requestWarning2confirmation = false;
                this.formReservationInfos_episode2warning2Checked = false;
                this.currentPopinName = 'choix-episode';
            }
        },
        creneauRoom_getAvailableType: function(creneau_key) {
            let room = this.destinations_and_rooms[this.currentScenario];

            // Specific multi-part rooms rules
            if (this.format_episode == 'full') {                
                if (this.creneaux_jour[creneau_key].type !== 'full' && this.creneaux_jour[creneau_key].type !== 'not_available') {
                    var should_stop_at_next_key = false;
                    var next_creneau_key = null;
                    for(var key in this.creneaux_jour) {
                        if (key == creneau_key) {
                            should_stop_at_next_key = true;
                        } else if (should_stop_at_next_key) {
                            next_creneau_key = key;
                            break;
                        }
                    }

                    if (next_creneau_key) {
                        return this.creneaux_jour[next_creneau_key].type;
                    } else {
                        return 'not_available';
                    }
                }
            }

            if (this.view_paymentDelayed) {
                if (this.creneaux_jour[creneau_key].type == 'full') {
                    return this.creneaux_jour[creneau_key].type;
                } else if (this.creneaux_jour[creneau_key].type == 'not_available') {
                    if (this.creneaux_jour[creneau_key].reservations[room]) {
                        return 'full';
                    } else {
                        return 'not_available';
                    }
                }

                return 'available';
            }

            if (this.creneaux_jour[creneau_key].type == 'full' || this.creneaux_jour[creneau_key].type == 'not_available') {
                return this.creneaux_jour[creneau_key].type;
            } else if (this.creneaux_jour[creneau_key].exceptions[room]) {
                return this.creneaux_jour[creneau_key].exceptions[room];
            }

            return this.creneaux_jour[creneau_key].type;
        },
        creneauxRoom_getAvailableType: function(creneau_keys) {
            if (this.view_paymentDelayed) {
                return 'available';
            }

            let room = this.destinations_and_rooms[this.currentScenario];
            for (var i = 0; i < this.creneaux_keys.length; i++) {
                if (this.creneaux_jour[this.creneaux_keys[i]].exceptions[room] 
                    && this.creneaux_jour[this.creneaux_keys[i]].exceptions[room] == 'available_phone') {
                    return 'available_phone';
                }
            }

            return 'available';
        },
        bonCadeauOuCodePromo_check: function(event) {
            if (!event.target.value || event.target.value.length == 0) {
                this.processGiftCardOrVoucherCodeResponse();
                return;
            }

            this.bonCadeauProcess_isChecking = true;

            var self = this;
            axios
                .get('https://api.lockquest.fr/voucher_code/' + event.target.value)
                    .then((response) => {
                        let processed = self.processGiftCardOrVoucherCodeResponse(response);
                        if (processed) {
                            self.bonCadeauOuCodePromoProcess_isChecking = false;
                        } else {
                            axios
                                .get('https://api.lockquest.fr/gift_card/' + event.target.value)
                                    .then((response) => {
                                        self.processGiftCardOrVoucherCodeResponse(response);
                                        self.bonCadeauProcess_isChecking = false;
                                    }).catch((error) => {
                                        self.bonCadeauOuCodePromoProcess_amount = 0;
                                        self.formReservationInfos_error = 'Le code que vous avez saisi est incorrect.';
                                        self.bonCadeauOuCodePromoProcess_isChecking = false;
                                    });
                        }
                    }).catch((error) => {
                        axios
                            .get('https://api.lockquest.fr/gift_card/' + event.target.value)
                                .then((response) => {
                                    self.processGiftCardOrVoucherCodeResponse(response);
                                    self.bonCadeauProcess_isChecking = false;
                                }).catch((error) => {
                                    self.bonCadeauOuCodePromoProcess_amount = 0;
                                    self.formReservationInfos_error = 'Le code que vous avez saisi est incorrect.';
                                    self.bonCadeauOuCodePromoProcess_isChecking = false;
                                });
                    });             
        },
        processGiftCardOrVoucherCodeResponse: function(response) {
            if (!response) {
                this.bonCadeauOuCodePromoProcess_amount = 0;
                this.formReservationInfos_error = null;

                return true;
            }

            if (response.data.available) {
                var bonCadeauOuCodePromo_amount = 0;
                switch(response.data.amount_type) {
                    case 'CURRENCY':
                        bonCadeauOuCodePromo_amount = response.data.amount_value;
                        break;
                    case 'DISCOUNT':
                        bonCadeauOuCodePromo_amount = this.tarifs[this.currentComposition] * (response.data.amount_value / 100);
                        break;
                    default:
                        bonCadeauOuCodePromo_amount = 0;
                        break;
                }

                if (bonCadeauOuCodePromo_amount > this.tarifs[this.currentComposition]) {
                    this.bonCadeauOuCodePromoProcess_amount = this.tarifs[this.currentComposition];
                } else {
                    this.bonCadeauOuCodePromoProcess_amount = bonCadeauOuCodePromo_amount;
                }
                this.formReservationInfos_error = null;

                return true;
            } else {
                this.bonCadeauOuCodePromoProcess_amount = 0;
                this.formReservationInfos_error = 'Le code que vous avez saisi a expiré ou a déjà été utilisé.';

                return false;
            }
        },
        performCreneauReservationInProgress: function() {
            this.currentPopinName = 'check-creneau-reservation-in-progress';

            var request_headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
            if (this.view_paymentDelayed) {
                let token = localStorage.getItem('admin-token');
                request_headers['Authorization'] = `Basic ` + token
            }

            axios.post('https://api.lockquest.fr/creneau/reservation_in_progress', {
                creneaux: [
                    {
                        day: this.calendarDay,
                        month: this.calendarMonth,
                        year: this.calendarYear,
                        creneau: this.currentCreneau,
                        room: this.destinations_and_rooms[this.currentScenario]
                    }
                ]
            }, {
                headers: request_headers
            }).then((response) => {
                this.currentPopinName = 'reservation-infos';
                axios
                    .get('https://api.lockquest.fr/tarifs')
                        .then((response) => {
                            this.tarifs = response.data;
                        })
                        .catch((error) => {
                            
                        });
            }).catch((error) => {
                this.currentPopinName = 'check-creneau-reservation-in-progress-error';
            });
        },
        refreshCreneauReservationInProgress: function() {
            this.currentPopinName = 'refresh-creneau-reservation-in-progress';

            var request_headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
            if (this.view_paymentDelayed) {
                let token = localStorage.getItem('admin-token');
                request_headers['Authorization'] = `Basic ` + token
            }

            axios.put('https://api.lockquest.fr/creneau/reservation_in_progress', {
                creneaux: [
                    {
                        day: this.calendarDay,
                        month: this.calendarMonth,
                        year: this.calendarYear,
                        creneau: this.currentCreneau,
                        room: this.destinations_and_rooms[this.currentScenario]
                    }
                ]
            }, {
                headers: request_headers
            }).then((response) => {
                this.performReservation();
            }).catch((error) => {
                this.currentPopinName = 'refresh-creneau-reservation-in-progress-error';
            });
        },
        performReservation: function() {
            this.currentPopinName = 'reservation-process';
            this.reservationProcess_message = 'Merci de patienter pendant l\'enregistrement de votre réservation...';

            var request_headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
            if (this.view_paymentDelayed) {
                let token = localStorage.getItem('admin-token');
                request_headers['Authorization'] = `Basic ` + token
            }

            var scenarios_data = [];
            if (this.format_episode && this.format_episode == 'full') {
                var should_stop_at_next_key = false;
                var scenarios_creneaux_key = [];
                for(var key in this.creneaux_jour) {
                    if (key == this.currentCreneau) {
                        scenarios_creneaux_key.push(key);
                        should_stop_at_next_key = true;
                    } else if (should_stop_at_next_key) {
                        scenarios_creneaux_key.push(key);
                        break;
                    }
                }

                for (var i = 0; i < 2; i++) {
                    scenarios_data.push({
                        creneau_day: this.calendarDay,
                        creneau_month: this.calendarMonth,
                        creneau_year: this.calendarYear,
                        creneau: scenarios_creneaux_key[i],
                        composition: this.currentComposition,
                        game_mode: this.currentGameMode,
                        scenario_slug: this.currentScenario,
                        format_episode: this.format_episode,
                        numero_episode: i+1
                    });
                }
            } else {
                scenarios_data.push({
                    creneau_day: this.calendarDay,
                    creneau_month: this.calendarMonth,
                    creneau_year: this.calendarYear,
                    creneau: this.currentCreneau,
                    composition: this.currentComposition,
                    game_mode: this.currentGameMode,
                    scenario_slug: this.currentScenario,
                    format_episode: this.format_episode,
                    numero_episode: this.numero_episode
                });
            }

            axios.post('https://api.lockquest.fr/reservation', {
                action: 'register',
                data: {
                    full_payment_requested: this.formReservationInfos_isFullPaymentRequested,
                    payment_delayed: this.view_paymentDelayed,
                    team_name: this.formReservationInfos_teamName,
                    last_name: this.formReservationInfos_lastName,
                    first_name: this.formReservationInfos_firstName,
                    email: this.formReservationInfos_email,
                    phone_number: this.formReservationInfos_phoneNumber,
                    business_name: this.formReservationInfos_businessName,
                    address: this.formReservationInfos_address,
                    zip_code: this.formReservationInfos_zipCode,
                    city: this.formReservationInfos_city,
                    language: this.formReservationInfos_language,
                    gift_card_or_voucher_code: this.formReservationInfos_giftCardOrVoucherCode,
                    scenarios: scenarios_data
                }
            }, {
                headers: request_headers
            }).then((response) => {
                if (response.data) {
                    this.moneticoFields = response.data;
                    
                    this.currentPopinName = 'reservation-process';
                    this.reservationProcess_message = 'Vous allez être rédirigé vers notre partenaire bancaire...';
                
                    var self = this;
                    setTimeout(function() {
                        self.$refs.moneticoForm.submit();
                    }, 1000);
                } else {
                    // Suppression de la pré-réservation
                    axios.delete('https://api.lockquest.fr/creneau/reservation_in_progress');
                    
                    this.reservationProcess_message = 'Votre réservation a été enregistrée !<br />Vous allez recevoir une confirmation '
                        + 'par e-mail. Merci et à bientôt !';
                }
            }).catch((error) => {
                this.reservationProcess_message = 'Une erreur est survenue, merci de contacter notre équipe.';
            });
        },
        formReservationInfos_bindClass: function(form_dataField) {
            return { 'has-error': this.formReservationInfos_isSubmit && (!form_dataField || form_dataField == '') };
        },
        payer_buttonClicked: function(fullPayment_isRequested) {
            this.formReservationInfos_isFullPaymentRequested = fullPayment_isRequested;
            this.formReservationInfos_isSubmit = true;

            if (!this.formReservationInfos_teamName || !this.formReservationInfos_lastName || !this.formReservationInfos_firstName
                || !this.formReservationInfos_email || !this.formReservationInfos_phoneNumber) {

                this.formReservationInfos_bindClass(this.formReservationInfos_teamName);
                this.formReservationInfos_bindClass(this.formReservationInfos_lastName);
                this.formReservationInfos_bindClass(this.formReservationInfos_firstName);
                this.formReservationInfos_bindClass(this.formReservationInfos_email);
                this.formReservationInfos_bindClass(this.formReservationInfos_phoneNumber);
                this.formReservationInfos_error = 'Veuillez remplir les champs indiqués en rouge avant de valider votre paiement';
            } else if (this.formReservationInfos_areTermsAgreed) {
                this.refreshCreneauReservationInProgress();
            } else {
                this.formReservationInfos_error = 'Vous devez accepter les C.G.V. avant de procéder au paiement de votre réservation';
            }
        },
        changer_onClick: function(event) {
            this.currentCreneau = null;
            this.currentComposition = null;
            this.currentGameMode = null;
            this.creneaux_keys = null;
            this.creneaux_jour = null;
            this.calendarLabel = null;
            this.calendarDay = null;
            this.calendarMonth = null;
            this.calendarYear = null;

            this.formReservationInfos_teamName = null;
            this.formReservationInfos_lastName = null;
            this.formReservationInfos_firstName = null;
            this.formReservationInfos_email = null;
            this.formReservationInfos_phoneNumber = null;
            this.formReservationInfos_businessName = null;
            this.formReservationInfos_address = null;
            this.formReservationInfos_zipCode = null;
            this.formReservationInfos_city = null;
            this.formReservationInfos_language = 'FR';
            this.formReservationInfos_giftCardOrVoucherCode = null;
            this.formReservationInfos_areTermsAgreed = false;
            this.formReservationInfos_episode2warning1Checked = false;
            this.formReservationInfos_episode2warning2Checked = false;
            this.formReservationInfos_isFullPaymentRequested = false;
            this.formReservationInfos_isSubmit = false;
            this.formReservationInfos_error = null;

            this.bonCadeauOuCodePromoProcess_isChecking = false,
            this.bonCadeauOuCodePromoProcess_amount = 0;

            this.reservationProcess_message = null;

            this.currentPopinName = 'reservation-creneau';
            if (this.currentScenario == 'la-legende-d-ishtar') {
                this.format_episode = null;
                this.numero_episode = null;
                this.should_requestWarning1confirmation = false;
                this.formReservationInfos_episode2warning1Checked = false;
                this.should_requestWarning2confirmation = false;
                this.formReservationInfos_episode2warning2Checked = false;
                this.currentPopinName = 'choix-episode';
            }

            var self = this;
            Vue.nextTick(function() {
                self.$refs.reservationCalendrier.initializeCalendrier();
            });
        },
        reserver_buttonClicked: function(event) {
            if (this.currentScenario == 'nestor-bomb-simulator') {
                // Skipping the game mode selection for "NESTOR - Bomb Simulator" room
                this.currentPopinName = 'check-creneau-reservation-in-progress';
                this.performCreneauReservationInProgress();
            } else {
                this.currentPopinName = 'choix-mode';
            }
        },
        popin_reservationDisplayed_callback(visible, entry) {
            if (!visible) {
                return;
            }

            this.isPopinLoaded = true;

            if (this.currentPopinName == 'reservation-creneau') {
                var self = this;
                Vue.nextTick(function() {
                    self.$refs.reservationCalendrier.initializeCalendrier();
                });
            }
        },
        popin_reservationDisplayed: function(scenario_slug) {
            this.currentScenario = scenario_slug;

            this.currentPopinName = 'reservation-creneau';
            if (this.currentScenario == 'la-legende-d-ishtar') {
                this.currentPopinName = 'choix-episode';
            }

            this.isPopinDisplayed = true;
        },
        popin_reservationClosed: function(event) {
            this.isPopinDisplayed = false;
            this.isPopinLoaded = false;

            this.currentPopinName = '';
            this.format_episode = null;
            this.numero_episode = null;
            this.should_requestWarning1confirmation = false;
            this.formReservationInfos_episode2warning1Checked = false;
            this.should_requestWarning2confirmation = false;
            this.formReservationInfos_episode2warning2Checked = false;

            this.reservationInProgress_identifier = null;
            this.currentScenario = null;
            this.currentCreneau = null;
            this.currentComposition = null;
            this.currentGameMode = null;
            this.creneaux_keys = null;
            this.creneaux_jour = null;
            this.calendarLabel = null;
            this.calendarDay = null;
            this.calendarMonth = null;
            this.calendarYear = null;

            this.formReservationInfos_teamName = null;
            this.formReservationInfos_lastName = null;
            this.formReservationInfos_firstName = null;
            this.formReservationInfos_email = null;
            this.formReservationInfos_phoneNumber = null;
            this.formReservationInfos_businessName = null;
            this.formReservationInfos_address = null;
            this.formReservationInfos_zipCode = null;
            this.formReservationInfos_city = null;
            this.formReservationInfos_language = 'FR';
            this.formReservationInfos_giftCardOrVoucherCode = null;
            this.formReservationInfos_areTermsAgreed = false;
            this.formReservationInfos_episode2warning1Checked = false;
            this.formReservationInfos_episode2warning2Checked = false;
            this.formReservationInfos_isFullPaymentRequested = false;
            this.formReservationInfos_isSubmit = false;
            this.formReservationInfos_error = null;

            this.bonCadeauOuCodePromoProcess_isChecking = false,
            this.bonCadeauOuCodePromoProcess_amount = 0;

            this.reservationProcess_message = null;
        },
        calendrier_daySelected: function(data) {
            this.creneaux_keys = [];
            for (var key in data.creneaux) {
                this.creneaux_keys.push(key);
            }
            this.creneaux_keys.sort();

            this.creneaux_jour = data.creneaux;
            this.calendarLabel = data.calendarLabel;
            this.calendarDay = data.calendarDay;
            this.calendarMonth = data.calendarMonth;
            this.calendarYear = data.calendarYear;

            this.currentCreneau = null;
            this.choixCreneau_bindClass(null);
            this.currentComposition = null;
            this.choixComposition_bindClass(null);
        },
        calendrier_dayUnselected: function() {
            this.creneaux_keys = null;
            this.creneaux_jour = null;
            this.calendarLabel = null;
            this.calendarDay = null;
            this.calendarMonth = null;
            this.calendarYear = null;

            this.currentCreneau = null;
            this.choixCreneau_bindClass(null);
            this.currentComposition = null;
            this.choixComposition_bindClass(null);
        },
        choixComposition_bindClass: function(composition) {
            if (!composition) {
                return;
            }
            
            var result = { active: this.currentComposition == composition };
            return result;
        },
        choixCreneau_bindClass: function(creneau_key) {
            if (!creneau_key) {
                return;
            }

            var result = { active: this.currentCreneau == creneau_key };
            if (this.view_paymentDelayed && this.creneauRoom_getAvailableType(creneau_key) !== 'full' && this.creneauRoom_getAvailableType(creneau_key) !== 'not_available') {
                result['available'] = true;
            } else {
                result[this.creneauRoom_getAvailableType(creneau_key)] = true;
            }
            return result;
        },
        choixComposition_click: function(event) {
            var composition_clicked = event.target.getAttribute('data-composition');
            this.currentComposition = composition_clicked;

            this.choixComposition_bindClass(this.currentComposition);
        },
        choixCreneau_click: function(event) {
            var creneau_clicked = event.target.getAttribute('data-creneau');

            if (this.creneauRoom_getAvailableType(creneau_clicked) !== 'available'
                && this.creneauRoom_getAvailableType(creneau_clicked) !== 'available_phone') {
                return;
            }

            if (this.currentCreneau == creneau_clicked) {
                this.currentCreneau = null;
            } else {
                this.currentCreneau = creneau_clicked;
            }
            this.choixCreneau_bindClass(this.currentCreneau);

            this.currentComposition = null;
            this.choixComposition_bindClass(this.currentComposition);
        },
        choixGameMode_click: function(game_mode) {
            this.currentGameMode = game_mode;
            
            this.currentPopinName = 'check-creneau-reservation-in-progress';
            this.performCreneauReservationInProgress();
        }
    }
}
</script>
